import type { ClinanceDocument, DocumentType } from '@/types/database';

export type { ClinanceDocument, DocumentType };

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  invoice: 'Nota fiscal',
  receipt: 'Recibo / Comprovante',
  contract: 'Contrato',
  bank_statement: 'Extrato bancário',
  tax: 'Imposto / Guia',
  payroll: 'Folha de pagamento',
  report: 'Relatório',
  other: 'Outro',
};

export const DOCUMENT_TYPE_COLORS: Record<DocumentType, string> = {
  invoice: 'bg-blue-100 text-blue-700',
  receipt: 'bg-green-100 text-green-700',
  contract: 'bg-purple-100 text-purple-700',
  bank_statement: 'bg-orange-100 text-orange-700',
  tax: 'bg-amber-100 text-amber-700',
  payroll: 'bg-teal-100 text-teal-700',
  report: 'bg-indigo-100 text-indigo-700',
  other: 'bg-gray-100 text-gray-600',
};

export const DOCUMENT_TYPE_OPTIONS: DocumentType[] = [
  'invoice',
  'receipt',
  'contract',
  'bank_statement',
  'tax',
  'payroll',
  'report',
  'other',
];

export const ALLOWED_DOCUMENT_MIME_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/csv',
  'text/plain',
  'application/zip',
  'application/x-rar-compressed',
];

export const MAX_DOCUMENT_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_DOCUMENT_SIZE_LABEL = '10MB';

export interface DocumentFilters {
  search: string;
  type: DocumentType | 'all';
  fromDate: string;
  toDate: string;
  transactionId?: string | null;
}

export const DEFAULT_DOCUMENT_FILTERS: DocumentFilters = {
  search: '',
  type: 'all',
  fromDate: '',
  toDate: '',
};
